var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1083.9 435c0.0625 36.227-7.043 72.109-20.914 105.58-13.871 33.469-34.227 63.859-59.898 89.422l-208.31 208.12-194.81 195-403.12-403.12c-34.23-34.215-58.852-76.832-71.387-123.58-12.539-46.746-12.551-95.965-0.035156-142.71s37.113-89.383 71.328-123.61c51.691-51.719 121.81-80.781 194.93-80.801 73.121-0.015625 143.25 29.016 194.97 80.707 3.5117 3.4922 8.2656 5.4531 13.219 5.4531s9.707-1.9609 13.219-5.4531c51.723-51.711 121.87-80.758 195.01-80.754 73.141 0 143.28 29.055 195 80.766 51.723 51.711 80.785 121.85 80.801 194.99z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlack);
export default __webpack_public_path__ + "static/media/StarBlack.6058a9491e6a6135886f99668ae3e805.svg";
export { ForwardRef as ReactComponent };